import { useContext, useMemo } from 'react';
import { RentalManagerEnvironmentContext } from '../components/RentalManagerEnvironmentProvider';

export const useMonitor = () => {
  const { environment } = useContext(RentalManagerEnvironmentContext);
  const { logger, monitor } = environment;

  return useMemo(() => {
    if (!monitor) {
      logger.error('No monitor set up');
      return () => {};
    }
    return monitor.count.bind(monitor);
  }, [monitor, logger]);
};
